import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import Pagination from "components/Pagination";
import Table from "components/Table";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import { useGetNotices } from "hooks/common/useGetNotices";
import { isNewPost } from "hooks/utils/util";
import { ReactComponent as ArrowDown } from "assets/morning/icon/arrowDownNavy.svg";
import speaker from "assets/common/support/notice_speaker.png";

export default function Notice({ type }: { type: string }) {
    const responsive700 = useMediaQuery(700);
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchForm, setSearchForm] = useState({
        category: type,
        search: "subject",
        searchtxt: "",
        page: 1,
        limit: 10,
    });
    const { data } = useGetNotices(searchForm);
    // console.log(data);

    useEffect(() => {
        const page = searchParams.get("page") ?? "1";
        if (page) {
            setSearchForm(prev => ({ ...prev, page: Number(page) }));
        }
    }, [searchParams]);

    useEffect(() => {
        setSearchForm(prev => ({
            ...prev,
            limit: responsive700 ? searchForm.limit / 2 : searchForm.limit,
        }));
    }, [responsive700]);

    return (
        <div
            className={`${responsive700 ? "bg-[#F3F5F8]" : "bg-[#f4f4f4]"} flex-1 flex flex-col items-center pb-16 pt-5 responsive1200:pt-[0px] responsive1200:px-[4%]`}
        >
            <p className="py-[35px] text-[#333] text-[28px] font-[600] responsive1200:py-[30px] responsive1200:text-[24px]">공지사항</p>
            <div
                className={`${responsive700 ? "bg-[#F3F5F8]" : "bg-white"} w-full max-w-[1200px] p-[50px] flex flex-col responsive1200:px-[4%] responsive700:px-0 responsive700:!pt-0`}
            >
                {/* 700 이하/이상 */}
                {responsive700 ? (
                    <>
                        <div className="flex flex gap-[5px] mb-[8px]">
                            <Select value={searchForm.search} onValueChange={value => setSearchForm(prev => ({ ...prev, search: value }))}>
                                <SelectTrigger
                                    className={`relative shadow-none text-[#1B1C1E] text-[16px] flex gap-[10px] rounded-[8px] focus:ring-${type} max-w-[150px] border border-[#E1E2E4] bg-white`}
                                >
                                    <SelectValue placeholder="" />
                                    <ArrowDown />
                                </SelectTrigger>
                                <SelectContent className="bg-white">
                                    <SelectItem value="subject">제목</SelectItem>
                                    <SelectItem value="contents">내용</SelectItem>
                                </SelectContent>
                            </Select>

                            <div className="relative flex-1">
                                <input
                                    type="text"
                                    value={searchForm.searchtxt}
                                    onChange={e => setSearchForm(prev => ({ ...prev, searchtxt: e.target.value, page: 1 }))}
                                    placeholder="검색어를 입력해주세요."
                                    className={`focus:!outline-${type} text-[16px] placeholder:text-[#878A93] border border-[#E1E2E4] rounded-[8px] w-full h-full px-[10px]`}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col gap-[8px] mb-[24px]">
                            {data?.data_list.length === 0 ? (
                                <p className="text-center py-[50px]">등록된 게시글이 없습니다.</p>
                            ) : (
                                <>
                                    {data?.data_list.map(item => {
                                        return (
                                            <Link
                                                to={`/support/notices/${item.list_no}`}
                                                key={item.list_no}
                                                className="rounded-[8px] bg-white px-[16px] py-[20px] flex flex-col gpa-[8px] border border-transparent active:border-[#FF7B2E] gap-[5px]"
                                            >
                                                <span className="text-[#878A93]">{item.w_date}</span>
                                                <div className="flex items-center gap-[5px]">
                                                    {item.notice === 1 && <img src={speaker} alt="" />}
                                                    <p className="truncate">{item.subject}</p>

                                                    {isNewPost(item.w_date) && (
                                                        <span className="w-[18px] h-[18px] bg-[#27398c] text-white flex items-center justify-center text-[10px] ml-[10px] shrink-0">
                                                            N
                                                        </span>
                                                    )}
                                                </div>
                                            </Link>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <div className="responsive700:hidden border-t border-b border-[#dddddd] bg-[#f8f8f8] flex gap-[10px] p-[15px] mb-[30px]">
                            <Select value={searchForm.search} onValueChange={value => setSearchForm(prev => ({ ...prev, search: value }))}>
                                <SelectTrigger
                                    className={`relative shadow-none text-[#1B1C1E] text-[16px] flex gap-[10px] rounded-none focus:ring-${type} max-w-[150px] border border-[#E1E2E4] bg-white`}
                                >
                                    <SelectValue placeholder="" />
                                    <ArrowDown />
                                </SelectTrigger>
                                <SelectContent className="bg-white">
                                    <SelectItem value="subject">제목</SelectItem>
                                    <SelectItem value="contents">내용</SelectItem>
                                </SelectContent>
                            </Select>

                            <div className="relative flex-1">
                                <input
                                    type="text"
                                    value={searchForm.searchtxt}
                                    onChange={e => setSearchForm(prev => ({ ...prev, searchtxt: e.target.value, page: 1 }))}
                                    placeholder="검색어를 입력해주세요."
                                    className={`focus:!outline-${type} text-[16px] placeholder:text-[#878A93] border border-[#E1E2E4] rounded-none w-full h-full px-[10px]`}
                                />
                            </div>
                        </div>

                        <Table
                            thead={[
                                // { title: "NO", width: "10%", key: "notice" },
                                {
                                    title: "제목",
                                    width: "64%",
                                    key: "subject",
                                    className: "cursor-pointer hover:underline text-[15px] text-[#666] truncate pr-[50px]",
                                    content: data => (
                                        <Link to={`${data.list_no}`} className="inline-block hover:underline">
                                            <div className="flex gap-[10px] items-center px-2">
                                                <span className="truncate">{data.subject}</span>
                                                {isNewPost(data.w_date) && (
                                                    <span className="w-[18px] h-[18px] bg-[#27398c] text-white flex items-center justify-center text-[10px] ml-[10px] shrink-0">
                                                        N
                                                    </span>
                                                )}
                                            </div>
                                        </Link>
                                    ),
                                },
                                { title: "등록일", width: "14%", key: "w_date", className: "text-[15px] text-[#666] text-center" },
                                { title: "조회수", width: "12%", key: "counter", className: "text-[15px] text-[#666] text-center" },
                            ]}
                            tbody={data?.data_list || []}
                            className="mb-[40px]"
                            totalCount={data?.total_count ?? 0}
                            currentPage={data?.current_page ?? 1}
                        />
                    </>
                )}

                <Pagination
                    current={searchForm.page}
                    total={data?.total_count || 1}
                    pageSize={responsive700 ? searchForm.limit / 2 : searchForm.limit}
                    groupSize={responsive700 ? searchForm.limit / 2 : searchForm.limit}
                    onChange={newPage => {
                        searchParams.set("page", String(newPage));
                        setSearchParams(searchParams);
                    }}
                />
            </div>
        </div>
    );
}
